import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class JournalEntryService extends DatabaseGwService{
     URL_PATH="/gls";
     isValidCreditDebit(lstJournalDetail){
      let totalCredit:number=0;
      let totalDebit:number=0;
        lstJournalDetail.forEach(journal_de => {
          totalCredit += Number(journal_de.credit_amount ? journal_de.credit_amount :0);
          totalDebit += Number(journal_de.debit_amount ? journal_de.debit_amount :0);
         
        });
        
        if(totalCredit !=0 && totalDebit !=0){
          return totalCredit==totalDebit;

        }
        
     }
     checkValidation(lstJL){
       let isValidate:number=0;
       lstJL.forEach(element => {
             if(element.coa_id==null){
              element.validField +=1;
              isValidate= element.validField;
             }
       });
       return isValidate<=0;
     }
     FormatData(lstJournal){
       let lstObj:any[]=[];
       let obj:any=[];
       lstJournal.forEach(element => {
         if(element.original_batch){
          obj=
          {
            id:element.id,
            batch_number:element.batch_number,
            status:element.status,
            ledger:element.accounting_book ? element.accounting_book.name :null,
            module:element.module,
            fin_period:element.fin_period,
            ledger_id:element.ledger_id,
            transaction_date:element.transaction_date,
            original_batch_number:element.original_batch.batch_number,
            is_reverse:element.is_reverse

          }
         }
         else{
          obj=
          {
            id:element.id,
            batch_number:element.batch_number,
            status:element.status,
            ledger:element.accounting_book ? element.accounting_book.name :null,
            module:element.module,
            fin_period:element.fin_period,
            ledger_id:element.ledger_id,
            transaction_date:element.transaction_date,
            original_batch_number:null,
            is_reverse:element.is_reverse

          }
         }
         
        
        
          lstObj.push(obj);

       });
       return lstObj;
     }

}
